import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { isValid, parse } from 'date-fns';

@Injectable()
export class PtBrDateAdapter extends NativeDateAdapter {
  override parse(value: unknown, _parseFormat?: unknown): Date | null {
    if (typeof value === 'string' && value.trim()) {
      const parsed = parse(value.trim(), 'dd/MM/yyyy', new Date());
      if (isValid(parsed)) return parsed;
    }
    return super.parse(value, _parseFormat);
  }
}
